import { render, staticRenderFns } from "./DrugSalesData.vue?vue&type=template&id=615fc92e"
import script from "./DrugSalesData.vue?vue&type=script&lang=js"
export * from "./DrugSalesData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports